import { Injectable } from '@angular/core';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ProductLine } from '../models/ProductLine';
import { SubAssembly } from '../models/subAssembly';
import { Assembly } from '../models/assembly';
import { ProductUnit } from '../models/ProductUnit';
import { Components } from '../models/component';
import { UserPlant } from '../models/userPlant';
import { SuccessMessage } from '../models/successMessage';
import { UserPermission } from '../models/userPermission';
import { Register } from '../models/register';
import { Userlist } from '../models/userlist';
import { UserMachine } from '../models/userMachine';
import { RolePermission } from '../models/rolePermission';
import { Role } from '../models/role';
import { ThemeService } from 'ng2-charts';

@Injectable({
  providedIn: 'root'
})
export class UserManagementService {
  // tslint:disable-next-line:typedef
  baseUrl2: string = Constants.CORE_API_BASE_URL;


  constructor(private http: HttpClient) { }

  getRoleMapData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl2 + 'Account/GetRoleMapList', data);
  }

  getGroupData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl2 + 'Common/GetGroup', data);
  }
  getDepartments(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl2 + 'Common/GetDepartments', data);
  }
  //NOT IN USE
  // adduserdepartment(data: any): Observable<any[]> {

  //   return this.http.post<any[]>(this.kpibaseUrl + 'adduserdepartment', data);
  // }

  //NOT IN USE
  // Updateuserdepartment(data: any): Observable<any[]> {

  //   return this.http.put<any[]>(this.kpibaseUrl + 'updateuserdepartment', data);
  // }
  getUsersData(key: any): Observable<any> {
    return this.http.get<any>(this.baseUrl2 + 'User/GetUsersByPlant');
  }

  //NOT IN USE
  // getusergroup(data: any): Observable<any[]> {
  //   return this.http.post<any[]>(this.kpibaseUrl + 'mastergroupuserdepartments', data);
  // }

  //NOT IN USE
  // getuserbydepartment(data: any): Observable<any[]> {
  //   return this.http.post<any[]>(this.kpibaseUrl + 'masteruserbydepartments', data);
  // }

  decryptPassword(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl2 + 'Account/DecryptPassword', data);
  }
  changeUserPassword(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl2 + 'Account/ChangeUserPassword', data);
  }

  validateOldPassword(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl2 + 'Account/ValidateOldPassword', data);
  }

  updateProfileImage(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl2 + 'Account/UpdateProfileImage', data);
  }

  submitUsersData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl2 + 'Account/SumbitUserManager', data);
  }
  getRoleList(data: any): Observable<any> {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post<any>(this.baseUrl2 + 'Account/GetRoles', data, { headers: header });
  }
  getRoleMenuList(data: any): Observable<any> {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post<any>(this.baseUrl2 + 'Account/GetRoleMenulist', data, { headers: header });
  }
  SumbitRoleDetails(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl2 + 'Account/SumbitRoleDetails', data);
  }
  SumbitRoleMap(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl2 + 'Account/SumbitRoleMap', data);
  }

  GetStatusData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl2 + 'Account/SumbitRoleMap', data);
  }

  //NOT IN USE
  // GetUsersByEgId(data: any): Observable<any[]> {

  //   return this.http.post<any[]>(this.kpibaseUrl + 'userbygroup', data);
  // }

  unlockUser(userId: number): Observable<any> {
    return this.http.get<any>(this.baseUrl2 + 'Account/UnlockUser/' + userId);
  }

  getUserById(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl2 + 'Account/GetUserById', data);
  }

  GetUsersByArea(data: any): Observable<any[]> {

    // return this.http.post<any[]>(this.kpibaseUrl + 'userbyarea', data);
    return this.http.post<any[]>(this.baseUrl2 + 'Users/GetUserByArea', data);
  }

  GetAuditClassifications(): Observable<any[]> {
    return this.http.get<any[]>(this.baseUrl2 + 'Classification/GetAuditClassifications');
  }

  //NOT IN USE
  // GetDMSClassifications(): Observable<any[]> {
  //   return this.http.get<any[]>(this.kpibaseUrl + 'dmsclassfications');
  // }

  getStatus(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl2 + 'Planner/GetStatus', data);
  }

  GetUOMData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl2 + 'Account/SumbitRoleMap', data);
  }

  GetMenulist(data: any): Observable<any[]> {
    console.trace();
    return this.http.post<any[]>(this.baseUrl2 + 'Account/GetMenulist', data);
  }
  GetSearchMenulist(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl2 + 'Account/GetSearchMenulist', data);
  }
  GetMenuChildList(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl2 + 'Common/GetMenuChildList', data);
  }
  GetBreadcrumList(data: any): Observable<any[]> {
    console.trace();

    return of(null);
  }



  getRoles(data: any): Observable<Role[]> {
    return this.http.post<Role[]>(this.baseUrl2 + 'roles', data);
  }
  addRole(role: any): any {
    return this.http.post(this.baseUrl2 + 'addrole', role);
  }
  getOneRole(role: any): Observable<any> {
    return this.http.post<any>(this.baseUrl2 + 'role', role);
  }
  updateRole(role: any): any {
    return this.http.put(this.baseUrl2 + 'role', role);
  }
  masterroles(data: any): any {
    return this.http.post(this.baseUrl2 + 'Roles/MasterRoles', data);
  }
  deleteRole(role: any): Observable<SuccessMessage> {
    return this.http.post<SuccessMessage>(this.baseUrl2 + 'deleterole', role);
  }
  rolePermissions(search: any): Observable<RolePermission[]> {
    return this.http.post<RolePermission[]>(
      this.baseUrl2 + 'rolepermissions',
      search
    );
  }
  updateRolePermissions(data: any): Observable<SuccessMessage> {
    return this.http.put<SuccessMessage>(
      this.baseUrl2 + 'rolepermissions',
      data
    );
  }
  registerUser(register: any): any {
    return this.http.post(this.baseUrl2 + 'register', register);
  }
  updateUser(register: any): any {
    return this.http.put(this.baseUrl2 + 'user', register);
  }
  deleteUser(register: any): any {
    return this.http.post(this.baseUrl2 + 'deleteuser', register);
  }
  getOneMachine(data: any): Observable<UserMachine> {
    return this.http.post<UserMachine>(this.baseUrl2 + 'onemachine', data);
  }
  saveMachineAccess(data: any): any {
    return this.http.post(this.baseUrl2 + 'addmachineaccess', data);
  }
  getUsers(data: any): Observable<Userlist[]> {
    return this.http.post<Userlist[]>(this.baseUrl2 + 'Users/users', data);
  }
  getRaciUsers(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl2 + 'Users/users', data);
  }
  getOneUser(data: any): Observable<Register> {
    return this.http.post<Register>(this.baseUrl2 + 'user', data);
  }
  userPermissions(data: any): Observable<UserPermission[]> {
    return this.http.post<UserPermission[]>(
      this.baseUrl2 + 'userpermissions',
      data
    );
  }
  updateUserPermissions(data: any): Observable<SuccessMessage> {
    return this.http.put<SuccessMessage>(
      this.baseUrl2 + 'userpermissions',
      data
    );
  }
  getUserPants(data: any): Observable<UserPlant[]> {
    return this.http.post<UserPlant[]>(this.baseUrl2 + 'userplant', data);
  }
  forgotPassword(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl2 + 'forgotpassword', data);
  }
  verifyOtp(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl2 + 'verifyotp', data);
  }
  updatePassword(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl2 + 'updatepassword', data);
  }
  getAllComponents(): Observable<Components[]> {
    return this.http.get<Components[]>(this.baseUrl2 + 'components');
  }
  getAllUnits(): Observable<ProductUnit[]> {
    return this.http.get<ProductUnit[]>(this.baseUrl2 + 'units');
  }
  getAllAssemblies(): Observable<Assembly[]> {
    return this.http.get<Assembly[]>(this.baseUrl2 + 'assemblies');
  }
  getAllSubAssemblies(): Observable<SubAssembly[]> {
    return this.http.get<SubAssembly[]>(this.baseUrl2 + 'subassemblies');
  }
  getAllLines(): Observable<ProductLine[]> {
    return this.http.get<ProductLine[]>(this.baseUrl2 + 'lines');
  }
  getMachineAccess(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl2 + 'machineaccess', data);
  }
  getSelectedNodesFlatArray(treeNode: any): any {
    const flatArray: any = [];
    const treeToFlat = (node: any): any => {
      if (node.data.IsSelect) {
        flatArray.push(node);
      }

      if (node.children.length) {
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < node.children.length; i++) {
          treeToFlat(node.children[i]);
        }
      }
    };

    treeToFlat(treeNode);

    return flatArray;
  }

  addMenuData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl2 + 'menu', data);
  }

  getMenuData(): Observable<any[]> {
    return this.http.get<any[]>(this.baseUrl2 + 'menu');
  }

  getOneMenuData(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl2 + 'onemenu', data);
  }

  updateMenuData(data: any): Observable<any[]> {
    return this.http.put<any[]>(this.baseUrl2 + 'menu', data);
  }

  deleteMenuData(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl2 + 'deletemenu', data);
  }
  getSelectedNodesMachineFlatArray(treeNode: any): any {
    const flatArray: any = [];
    const treeToFlat = (node: any): any => {
      if (node.partialSelected) {
        flatArray.push(node);
      }

      if (node.children.length) {
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < node.children.length; i++) {
          treeToFlat(node.children[i]);
        }
      }
    };

    treeToFlat(treeNode);

    return flatArray;
  }

  GetShiftStart(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl2 + 'SDFC/GetShiftStart', data);
  }

  SubmitShiftStart(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl2 + 'SDFC/SubmitShiftStart', data);
  }

  GetMenuChilds(menuId: string): Observable<any[]> {
    return this.http.get<any[]>(this.baseUrl2 + 'menu/getMenuChildsByParentId/' + menuId);
  }
  LogOut(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl2 + 'Auth/LogOutAudit', data);
  }

  LogoutUser(): Observable<any[]> {
    return this.http.get<any>(this.baseUrl2 + 'Auth/LogOutAudit');
  }
}
